var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"bc-item",class:{'hasarrow' : index !== (_vm.list.length - 1), 'cursor': item.url},on:{"click":function($event){return _vm.itemClick(item)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }